import { NgModule } from '@angular/core';
import {EnvTypeRotateComponent} from './environmentTypeRotator'
import {RotatorItemModule} from './rotatorItem/rotatorItem.module'
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common'

@NgModule({
    imports: [ FormsModule,RotatorItemModule,CommonModule],
    declarations: [
        // EnvironmentItemComponent,
        EnvTypeRotateComponent
    ],
    entryComponents: [
        EnvTypeRotateComponent
    ],
    exports: [
        EnvTypeRotateComponent
    ]
})
export class EnvironmentTypeRotatorModule {
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/environmentTypeRotator/environmentTypeRotator.module.ts